import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import AuthImg from "../assets/svg/AuthImg.svg";
const AuthLayout = () => {
  useEffect(() => {
    document.body.style.backgroundImage = "none";
    return () => {};
  }, []);

  return (
    <div className="d-flex flex-column flex-lg-row flex-column-fluid h-100">
      {/* Left Side */}
      <div className="d-flex bg-white flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-1 ">
        <div
          className="h-100 w-100 text-center"
          style={{
            backgroundImage: `url(${AuthImg})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="fs-32px d-none  d-lg-block fw-bold text-white  pt-15">
            Smart Hiring Automation
          </div>
          <div className="fs-3 text-white d-none  d-lg-block">
            Automate your recruitment workflow and save time.
          </div>
        </div>
      </div>

      {/* Right Side */}
      <div
        className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 rounded-0 card order-lg-2"
        style={{ height: "100vh", overflow: "auto" }}
      >
        <div className="d-flex flex-center flex-column flex-lg-row-fluid">
          <img src="/BizroIcon.svg" className="h-75px" alt="logo" />
          <div className="  w-100 p-1 p-md-10">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};
export default AuthLayout;
